import React from 'react';
import { Link } from 'react-router-dom';

const Logo: React.FC = () => {
  return (
    <Link to="/" className="group flex min-w-0 items-center gap-2 transition-transform hover:scale-105 sm:gap-3">
      <div className="relative">
        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 opacity-0 blur-lg transition-opacity group-hover:opacity-70" />
        <img 
          src="/assets/images/logo/NEXLogo.png" 
          alt="Nex Computer" 
          className="relative h-9 w-auto max-w-[52px] object-contain transition-transform group-hover:rotate-2 sm:h-11 sm:max-w-none"
        />
      </div>
      <div className="hidden min-w-0 sm:block">
        <span className="block whitespace-nowrap text-base font-black tracking-tight bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent lg:text-xl">
          Nex Computer
        </span>
        <span className="block whitespace-nowrap text-[8px] font-bold uppercase tracking-widest text-slate-400 lg:text-[10px]">
          Solution via Dedication
        </span>
      </div>
    </Link>
  );
};

export default Logo;
